import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private ws: PostmethodService) { }


  createCountry(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "masters/countries");
  }

  getCountry() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }

  updateCountry(request: any, id: any) {
    return this.ws.wsPut(request, environment.baseUrl + "masters/countries", id);
  }
}
